

import React from 'react';

export const BuildingOverviewSection: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            통합개발 시 건축 개요 예시
          </h2>
          <p className="text-lg text-gray-600">
            대청마을 북측 통합개발 건축 계획 및 세부 사항
          </p>
        </div>
        
        <div className="max-w-6xl mx-auto">
          {/* 건축 개요 이미지 */}
          <div className="relative mb-12">
            <div className="bg-white rounded-lg shadow-xl overflow-hidden">
              <div className="relative">
                <img
                  src="https://static.readdy.ai/image/4a2a6b477d2273a3d0d5c5a7079aba9a/67cad1c10818e731377ad4930caee746.jpeg"
                  alt="통합개발 시 건축 개요 예시"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm rounded-lg px-4 py-2 shadow-md">
                  <p className="text-sm font-semibold text-gray-900">건축 개요</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* 건축 개요 상세 정보 */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="bg-yellow-50 rounded-lg p-6 border-l-4 border-yellow-400">
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 bg-yellow-100 rounded-full flex items-center justify-center mr-3">
                  <span className="text-sm font-bold text-yellow-600">1구역</span>
                </div>
                <h4 className="text-xl font-semibold text-gray-900">1구역</h4>
              </div>
              <div className="space-y-3">
                <div className="text-center">
                  <div className="text-2xl font-bold text-yellow-600 mb-1">15,659㎡</div>
                  <div className="text-sm text-gray-600">면적</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-yellow-600 mb-1">410세대</div>
                  <div className="text-sm text-gray-600">세대수</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-yellow-600 mb-1">20.96%</div>
                  <div className="text-sm text-gray-600">임대비율</div>
                </div>
              </div>
            </div>
            
            <div className="bg-green-50 rounded-lg p-6 border-l-4 border-green-400">
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3">
                  <span className="text-sm font-bold text-green-600">2구역</span>
                </div>
                <h4 className="text-xl font-semibold text-gray-900">2구역</h4>
              </div>
              <div className="space-y-3">
                <div className="text-center">
                  <div className="text-2xl font-bold text-green-600 mb-1">36,216㎡</div>
                  <div className="text-sm text-gray-600">면적</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-green-600 mb-1">982세대</div>
                  <div className="text-sm text-gray-600">세대수</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-green-600 mb-1">20.67%</div>
                  <div className="text-sm text-gray-600">임대비율</div>
                </div>
              </div>
            </div>
            
            <div className="bg-blue-50 rounded-lg p-6 border-l-4 border-blue-400">
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                  <span className="text-sm font-bold text-blue-600">3구역</span>
                </div>
                <h4 className="text-xl font-semibold text-gray-900">3구역</h4>
              </div>
              <div className="space-y-3">
                <div className="text-center">
                  <div className="text-2xl font-bold text-blue-600 mb-1">35,697㎡</div>
                  <div className="text-sm text-gray-600">면적</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-blue-600 mb-1">976세대</div>
                  <div className="text-sm text-gray-600">세대수</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-blue-600 mb-1">20.59%</div>
                  <div className="text-sm text-gray-600">임대비율</div>
                </div>
              </div>
            </div>
          </div>
          
          {/* 총 건축 규모 */}
          <div className="mt-12 bg-gray-50 rounded-lg p-8">
            <h4 className="text-xl font-bold text-gray-900 mb-6 text-center">전체 개발 규모</h4>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600 mb-2">87,572㎡</div>
                <div className="text-gray-600">총 면적</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-green-600 mb-2">2,368세대</div>
                <div className="text-gray-600">총 세대수</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-purple-600 mb-2">20.69%</div>
                <div className="text-gray-600">임대비율</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

